import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1161px;
  margin: 0 auto;

  > h1 {
    text-align: center;
  }
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 24px;

  @media (min-width: 640px) {
    justify-content: start;
  }
`;

export const FormFilter = styled.form`
  padding: 32px 16px;
  width: 100%;
  max-width: 978px;
  border-radius: 10px;
  border: 1px solid #9d9d9d;
  margin-bottom: 24px;
  grid-template-areas: "nome" "cpf" "telefone" "email" "buttons";
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px 16px;

  > :nth-child(1) {
    grid-area: nome;
  }

  > :nth-child(2) {
    grid-area: cpf;
  }

  > :nth-child(3) {
    grid-area: telefone;
  }

  > :nth-child(4) {
    grid-area: email;
  }

  > :nth-child(5) {
    grid-area: buttons;
    display: flex;
    justify-content: center;
    gap: 16px;
  }

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas: "nome nome cpf" "telefone email buttons";
    padding: 32px;

    > :nth-child(5) {
      gap: 0 48px;
    }
  }
`;

export const Table = styled.div`
  margin-bottom: 32px;
  > div + div {
    margin-top: 16px;
  }
`;

export const TableItem = styled.div`
  border-radius: 10px;
  background: #e8e8e8;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #2d2d2d;
    font-family: Mulish;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: 0.36px;
    text-transform: uppercase;

    span {
      font-weight: 400;
    }
  }
`;
